import React from 'react';
import Close from '../../../../../Icons/16x16/Close';

import LargeInputIconButton, {
  type LargeInputIconButtonProps,
} from '../LargeInputIconButton';

interface Props
  extends Omit<LargeInputIconButtonProps, 'aria-label' | 'icon' | 'size'> {}

const ClearButton: React.FC<Props> = props => {
  return (
    // No translations in da-ds, so hard coding the a11y label
    <LargeInputIconButton
      aria-label="Clear"
      icon={Close}
      size="small"
      {...props}
    />
  );
};

ClearButton.displayName = 'ClearButton';

export default ClearButton;
